import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=5ce0e5b8&scoped=true"
import script from "./grade.vue?vue&type=script&lang=js"
export * from "./grade.vue?vue&type=script&lang=js"
import style0 from "./grade.vue?vue&type=style&index=0&id=5ce0e5b8&prod&lang=less&scoped=true"
import style1 from "./grade.vue?vue&type=style&index=1&id=5ce0e5b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce0e5b8",
  null
  
)

export default component.exports